import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import MessageProvider from 'studio/components/Message';
import LoaderProvider from 'components/loaders/FadeLoader';
import { contextPath } from 'config/baseURL';
import App from './App/App';
import 'root/styles/constants.css'; // import global config constants
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ConfirmationModalProvider, KnowledgeGraphProvider } from 'hooks';

const renderApp = () => {
  render(
    <ConfirmationModalProvider>
      <KnowledgeGraphProvider>
        <LoaderProvider>
          <MessageProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Router basename={contextPath}>
                <App />
              </Router>
            </LocalizationProvider>
          </MessageProvider>
        </LoaderProvider>
      </KnowledgeGraphProvider>
    </ConfirmationModalProvider>,
    document.getElementById('app')
  );
};

renderApp();
